import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import Newnavigation from '../../../components/new-navigation/new_navigation';
import AboutusBanner from '../../../components/Aboutus-banner/AboutusBanner';
import ContactNew from '../../../components/contact-form/ContactNew';
import Footer from '../../../components/footer/Footer';
import { RETAIL_ECOMMERCE, WAREHOUSING_BANNER} from '../../../assets/images';
import { datawarehousing_heading, DataWarehousingAccord, CoreServices,WhyTechno,TestimonialData } from '../../../utils/data-warehousing';
import {  Retail_Ecommerce, WarehousingSeo} from '../../../utils/Seo';
import HeaderSeo from '../../../components/HeaderSeo/Headerseo';
import ComAccord from '../../../components/Accordian/ComAccord';
import RetailProgress from '../../../components/RetailProgress/RetailProgress';
import CoreServicesList from '../../../components/core-serices/core-services';
import Testimonials from '../../../components/Testimonials/Testimonials';


const DataWarehousing = () => {
  const sectionRef = useRef()
  const refcustom = sectionRef.current
    useEffect(() => {
        window.scroll({
          top: 0,
          behavior: "smooth",
        });
      }, []);
    return (
        <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
    >
        <div className='service-page' ref={sectionRef}>
            <Newnavigation routeName="services"/>
            <HeaderSeo data={WarehousingSeo}/>
            <AboutusBanner bg={WAREHOUSING_BANNER} data={datawarehousing_heading}/>
            <CoreServicesList title="Our Core Data Warehousing Services" data={CoreServices} />
            <RetailProgress steps={WhyTechno} heading={"Why Choose Techno Genesis for Data Warehousing?"}/>
            <Testimonials data={TestimonialData} />
            <div className="mb-50">
              <ComAccord data={DataWarehousingAccord} />
            </div>
            <ContactNew />
            <Footer />
        </div>
        </motion.div>
    )
}

export default DataWarehousing